export default "__VITE_ASSET__DFMcquzG__"